// Home page - AI landing page

import { HeroSection } from '../components/sections/HeroSection';
import { ExperienceSection } from '../components/sections/ExperienceSection';
import { SkillsMatrix } from '../components/sections/SkillsMatrix';
import { FitAssessment } from '../components/sections/FitAssessment';
import { useCandidateData } from '../hooks/useCandidateData';

interface HomeProps {
  onAskAiClick: () => void;
}

export function Home({ onAskAiClick }: HomeProps) {
  const { profile, experiences, skills, isLoading } = useCandidateData();

  return (
    <main>
      <HeroSection
        name={profile?.name}
        title={profile?.title}
        elevatorPitch={profile?.elevator_pitch}
        availabilityStatus={profile?.availability_status}
        onAskAiClick={onAskAiClick}
      />

      <ExperienceSection experiences={experiences} isLoading={isLoading} />

      <SkillsMatrix skills={skills} isLoading={isLoading} />

      <FitAssessment />
    </main>
  );
}
